"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navMain = void 0;
const navMain = () => {
    const navToggle = (target, item, list) => {
        if (!list.classList.contains('is-active')) {
            item.querySelector('[data-toggle="nav"]').setAttribute('aria-expanded', 'true');
        }
        else {
            item.querySelector('[data-toggle="nav"]').setAttribute('aria-expanded', 'false');
        }
        item.classList.toggle('is-open');
        list.classList.toggle('is-active');
        closeAll(target, item, list);
    };
    const closeAll = (target, item, list) => {
        let navButtons = document.querySelectorAll('[data-toggle="nav"]');
        let navLists = document.querySelectorAll('.main-menu__reveal');
        for (let navButton of navButtons) {
            if (navButton !== target) {
                navButton.closest('.main-menu__item').classList.remove('is-open');
                navButton.setAttribute('aria-expanded', 'false');
            }
        }
        for (let navList of navLists) {
            if (navList !== list) {
                navList.classList.remove('is-active');
            }
        }
    };
    document.addEventListener('click', function (event) {
        const target = event.target;
        if (!target.matches('[data-toggle="nav"]'))
            return;
        const navItem = target.closest('.main-menu__item');
        const subNavList = navItem.querySelector('.main-menu__reveal');
        navToggle(target, navItem, subNavList);
    }, false);
};
exports.navMain = navMain;
